import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Startups from './pages/Startups';
import About from './pages/About';
import DetailPage from './pages/DetailPage';

export default ({ location }) => (
  <Switch location={location} key={location.pathname}>
    <Route path="/startups" component={Startups} key="startups" />
    <Route exact path="/about" component={About} key="about" />
    <Route exact path="/detail" component={DetailPage} key="about" />
    <Route exact path="/" component={Startups} key="startups" />
  </Switch>
);

// <Route exact path="/detail/:id" component={DetailPage} key="detail" />
